import React, { useState } from 'react';
import { StyleSheet, Pressable, ActivityIndicator, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    gap: 8,
  },
  loadingContainer: {
    opacity: 0.7,
  }
});

const BasicTableRowLoadMoreButton = ({ onPress, isLoading }) => {
  const { colors } = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Pressable 
      onPress={onPress}
      disabled={isLoading}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
    >
      <View style={[
        styles.container,
        isLoading && styles.loadingContainer,
        isHovered && { backgroundColor: colors.solid_color_tertiary }
      ]}>
        {isLoading ? (
          <ActivityIndicator size="small" color={colors.text_color_secondary} />
        ) : (
          <>
            <Text size='n' weight='medium'color='secondary'>
              Load more
            </Text>
            <Icon name="chevron-down" size={10} color={colors.text_color_secondary} />
          </>
        )}
      </View>
    </Pressable>
  );
};

export default React.memo(BasicTableRowLoadMoreButton); 